import { combineReducers } from '@reduxjs/toolkit';
import associationsReducer from './ducks/Association';
import cobapReducer from './ducks/Cobap';
import CompanyStatusReducer from './ducks/Company';
import CustomerReducer from './ducks/Customer';
import dashboardReducer from './ducks/Dashboard';
import federationsReducer from './ducks/Federation';
import FilesStatusReducer from './ducks/Files';
import groupsReducer from './ducks/Groups';
import parameterizationsReducer from './ducks/Parameterizations';
import PartnerStatusReducer from './ducks/Partner';
import productReducer from './ducks/Product';
import productGroupingReducer from './ducks/ProductGrouping';
import benefitReducer from './ducks/Benefit';
import coverageReducer from './ducks/Coverage';
import billingGrupoReducer from './ducks/BillingGrupo';
import ProposalStatusReducer from './ducks/Proposal';
import reasonReducer from './ducks/Reason';
import reportsReducer from './ducks/Reports';
import reportsCobapReducer from './ducks/Reports/cobap';
import settingsReducer from './ducks/Settings';
import SignaturesStatusReducer from './ducks/Signature';
import signerReducer from './ducks/Signer';
import userReducer from './ducks/User';

const rootReducer = combineReducers({
  cobap: cobapReducer,
  dashboard: dashboardReducer,
  groups: groupsReducer,
  proposal: ProposalStatusReducer,
  customer: CustomerReducer,
  files: FilesStatusReducer,
  partner: PartnerStatusReducer,
  company: CompanyStatusReducer,
  reports: combineReducers({ general: reportsReducer, cobap: reportsCobapReducer }),
  signatures: SignaturesStatusReducer,
  signer: signerReducer,
  user: userReducer,
  association: associationsReducer,
  parameterization: parameterizationsReducer,
  federation: federationsReducer,
  reason: reasonReducer,
  settings: settingsReducer,
  product: productReducer,
  productGrouping: productGroupingReducer,
  benefit: benefitReducer,
  coverage: coverageReducer,
  billingGrupo: billingGrupoReducer,
});

export default rootReducer;
